module.exports = __webpack_public_path__ + "img/question_select.1f755f51.svg";